import "moment/locale/it";
import { errorsReducer, errorsSaga } from "ra-remote-validator";
import * as React from "react";
import { Admin, Resource, setAutomaticRefresh } from "react-admin";
import { Route } from "react-router-dom";
import authProvider from "./authProvider";
import bonusComparators from "./bonus-comparators";
import bookmakerApprovals from "./bookmaker-approvals";
import bookmakerChannels from "./bookmaker-channels";
import bookmakerDeals from "./bookmaker-deals";
import bookmakerImports from "./bookmaker-imports";
import bookmakerLandings from "./bookmaker-landings";
import bookmakerBlacklist from "./bookmaker-lists/blacklist";
import bookmakerWhitelist from "./bookmaker-lists/whitelist";
import bookmakers from "./bookmakers";
import channels from "./channels";
import Menu from "./components/Menu";
import contestAdjustments from "./contest-adjustments";
import contestStats from "./contest-stats";
import contests from "./contests";
import contestsBookmakers from "./contests-bookmakers";
import customLayout from "./customLayout";
import Dashboard from "./dashboard";
import dataProvider from "./dataProvider";
import deals from "./deals";
import dynamicVariablesStats from "./dynamic-variables-stats";
import events from "./events";
import i18nProvider from "./i18nProvider";
import languageMessages from "./language-messages";
import notifications from "./notifications";
import pages from "./pages";
import profile from "./profile";
import referralUsers from "./referral-users";
import rewards from "./rewards";
import stats from "./stats";
import statsDeclinated from "./stats-declinated";
import statsReset from "./stats-reset";
import theme from "./theme";
import useI18nCatcher from "./useI18nCatcher";
import useLanguages from "./useLanguages";
import userPayments from "./user-payments";
import userProfileApprovals from "./user-profile-approvals";
import userWtrs from "./user-wtrs/";
// import Dashboard from "./dashboard";
import users from "./users";
import LoginPage from "./users/pages/LoginPage";
import PasswordChangePage from "./users/pages/PasswordChangePage";
import PasswordResetPage from "./users/pages/PasswordResetPage";
import SignupPage from "./users/pages/SignupPage";

const App = () => {
	React.useEffect(() => {
		setAutomaticRefresh(false);
	}, []);
	useI18nCatcher();
	const { loading, languages } = useLanguages();
	if (loading) {
		return null;
	}

	return (
		<Admin
			menu={Menu}
			theme={theme}
			dashboard={Dashboard}
			dataProvider={dataProvider}
			authProvider={authProvider}
			i18nProvider={i18nProvider(languages)}
			loginPage={LoginPage}
			layout={customLayout}
			customReducers={{
				errors: errorsReducer,
			}}
			customSagas={[errorsSaga]}
			customRoutes={[
				<Route
					path="/password-reset"
					component={PasswordResetPage}
					noLayout
					options={{ menu: false }}
				/>,
				<Route path="/password-change" component={PasswordChangePage} />,
				<Route
					path="/signup"
					component={SignupPage}
					noLayout
					options={{ menu: false }}
				/>,
				<Route key="profile" path="/profile" component={profile.edit} />,
				<Route
					key="stats-reset"
					path="/stats-reset"
					component={statsReset.edit}
				/>,
			]}
		>
			<Resource name="stats" {...stats} />
			<Resource name="dynamic-variables-stats" {...dynamicVariablesStats} />
			<Resource name="stats-declinated" {...statsDeclinated} />
			<Resource name="user-payments" {...userPayments} />
			<Resource name="user-wtrs" {...userWtrs} />
			<Resource name="notifications" {...notifications} />
			<Resource name="users" {...users} />
			<Resource name="user-profile-approvals" {...userProfileApprovals} />
			<Resource name="events" {...events} />
			<Resource name="user-payment-statuses" />
			<Resource name="user-payments/ranges" />
			<Resource name="bookmakers" {...bookmakers} />
			<Resource name="bookmaker-deals" {...bookmakerDeals} />
			<Resource name="bookmaker-approvals" {...bookmakerApprovals} />
			<Resource name="bookmaker-channels" {...bookmakerChannels} />
			<Resource name="bookmaker-landings" {...bookmakerLandings} />
			<Resource name="bookmaker-blacklists" {...bookmakerBlacklist} />
			<Resource name="bookmaker-whitelists" {...bookmakerWhitelist} />
			<Resource name="bookmaker-imports" {...bookmakerImports} />
			<Resource name="bonus-comparators" {...bonusComparators} />
			<Resource name="pages" {...pages} />
			<Resource name="referral-users" {...referralUsers} />
			<Resource name="deals" {...deals} />
			<Resource name="channels" {...channels} />
			<Resource name="stats-declinated/ranges" />
			<Resource name="bookmaker-types" />
			<Resource name="bookmaker-platforms" />
			<Resource name="payment-methods" />
			<Resource name="roles" />
			<Resource name="groups" />
			<Resource name="languages" />
			<Resource name="profile" />
			<Resource name="stats-reset" />
			<Resource name="resources" />
			<Resource name="language-messages" {...languageMessages} />
			<Resource name="contest-stats" {...contestStats} />
			<Resource name="contests" {...contests} />
			<Resource name="rewards" {...rewards} />
			<Resource name="contests-bookmakers" {...contestsBookmakers} />
			<Resource name="contest-adjustments" {...contestAdjustments} />
		</Admin>
	);
};
export default App;
